import { render, staticRenderFns } from "./createCouTable.vue?vue&type=template&id=69e6956e&"
import script from "./createCouTable.vue?vue&type=script&lang=js&"
export * from "./createCouTable.vue?vue&type=script&lang=js&"
import style0 from "./createCouTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports